
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Rule, ConditionValue } from "@/types/conditions";
import { configStore } from "@/store/store-accessor";
import DynamicDataFieldText from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataFieldText.vue";
import { isDynamicShortcode } from "@/lib/dynamic-data/utils";
import CodeInput from "@/components/Reusable/CustomInputs/CodeInput/CodeInput.vue";
import { appendProToProConditionsLabelInFreeMode } from "@/lib/subscriptions/free-mode";

@Component({
  components: { CodeInput, DynamicDataFieldText }
})
export default class ConditionsPreview extends Vue {
  @Prop()
  rule!: Rule;

  @Prop()
  index!: number;

  get isMultipleValue() {
    return Array.isArray(this.rule.value);
  }

  get label() {
    const condition = configStore.conditions.find(
      condition => condition.slug === this.rule.ruleSlug
    );

    return condition
      ? appendProToProConditionsLabelInFreeMode(condition.label, condition)
      : this.rule.ruleSlug;
  }

  get isDynamicValue() {
    if (Array.isArray(this.rule.value)) {
      return false;
    }

    return isDynamicShortcode(this.rule.value);
  }

  get isCustomPHP() {
    return this.rule.ruleSlug === "custom-php";
  }

  get delimitedValue() {
    if (!Array.isArray(this.rule.value)) {
      return this.rule.value;
    }

    // "as" necessary because TS doesn't like different types of arrays together.
    // This is semantically different but offers the same type safety (https://github.com/microsoft/TypeScript/issues/7960#issuecomment-254919625)
    const typeSafeValue = this.rule.value as (string | ConditionValue)[];

    return typeSafeValue
      .map(value => {
        if (typeof value === "string") {
          return value;
        }

        return value.text;
      })
      .join(", ");
  }

  get ruleHasValue() {
    if (Array.isArray(this.rule.value)) {
      return this.rule.value.length;
    }
    return this.rule.value !== undefined && this.rule.value !== "";
  }
}
